module.exports = __webpack_public_path__ + "static/media/DSC_0278.d39ae59c.JPG";